import styles from '../styles/DepositCard.module.css'
import {} from 'react-icons'
import { useEffect, useRef, useState } from 'react';
import { ethers,  } from 'ethers';
import Web3Modal from 'web3modal'
import { Abi } from '../constants/Abi';
import { useStateValue } from '../context/StateProvider'
import { actionType } from '../context/reducer';
import { Success } from './Success';
import { Error } from './Error';




const Address = '0x4623e73aF94Ea2F29b89136392b38D352FC1410D';

export const DepositCard = () => {
    const web3ModalRef = useRef();
    const [ {success, error}, dispatch ] = useStateValue();
    
    const [amount,setAmount] = useState(0);
    const [{refAddress}] = useStateValue()



    const handleDeposit = async () => {
        const provider = await web3ModalRef.current.connect();
        const web3Provider = new ethers.providers.Web3Provider(provider);
        const signer = await web3Provider.getSigner();
        console.log(web3Provider,signer);

        const Vault = new ethers.Contract(
            Address,
            Abi,
            signer
        );
        try {
           const response = await Vault.buyEggs(refAddress, {value: ethers.utils.parseEther((amount).toString()), gasLimit: 300000});
           console.log(response)
           dispatch({
            type: actionType.SET_SUCCESS,
            success: true
           })
           setTimeout(() => {
            dispatch({
                type: actionType.SET_SUCCESS,
                success: false
            })
           }, 6000);
           
        } catch (error) {
           console.log(error);
           dispatch({
            type: actionType.SET_ERROR,
            error: true
           })
           setTimeout(() => {
            dispatch({
                type: actionType.SET_ERROR,
                error: false
            })
           }, 6000);
        };
    }

    //handleCompound 
    const handleCompound = async () => {
        const provider = await web3ModalRef.current.connect();
        const web3Provider = new ethers.providers.Web3Provider(provider);
        const signer = await web3Provider.getSigner();


        const Vault = new ethers.Contract(
            Address,
            Abi,
            signer,
        );
        try {
            const response = await Vault.hatchEggs(refAddress);
            console.log(response);
        } catch (error) {
           console.log('error:',error) 
        }
    }

    //handleClaim
    const handleClaim = async () => {
        const provider = await web3ModalRef.current.connect();
        const web3Provider = new ethers.providers.Web3Provider(provider);
        const signer = await web3Provider.getSigner();

        const Vault = new ethers.Contract(
            Address,
            Abi,
            signer,
        );
        try {
            const response = await Vault.sellEggs();
            console.log(response)
        } catch (error) {
            console.log(error)
        }
    }
    

    
    
    const handleIncrease = () => {
        console.log("increased")
        setAmount(amount + 0.1);
    }

    const handleDecrease = () => {
        console.log('earn knan')
        setAmount(amount - 0.1);
    }

    useEffect(() => {
        web3ModalRef.current = new Web3Modal({
            network: 'rinkeby',
            providerOptions: {},
        })
    },[])
   

    return(
    
    <div className={styles.container}>
        <div className={styles.card}>
            <div className={styles}>
                <div className={styles.inp}> 
                  <input  className={styles.inp} placeholder='Enter MATIC Amount' type='number'  min='2'  onChange={(e) => setAmount(e.target.value)} />
                </div>
                <div className={styles.errorfield}>
                   {success && <Success />}
                   {error && <Error name="Transaction Error"/>}
                </div>
                <div className={styles.btngrp}>
                    <button onClick={handleDeposit} className={styles.btn}>Deposit to Vault</button>
                
                    <button onClick={handleCompound}  className={styles.btn}>Hire Miners Compound</button>
               
                    <button onClick={handleClaim} className={styles.btn}>Claim</button>
                </div>
            </div>
        </div>
    </div>
    );
}